import About from '~cp/Public/About.vue'
import Reviews from '~cp/Public/Reviews.vue'
import ComingSoon from '~cp/Public/ComingSoon.vue'
import AdditionalService from '~cp/Public/AdditionalService.vue'
import AdditionalServiceBlog from '~cp/Public/AdditionalServiceBlog.vue'
import AdditionalServiceHelp from '~cp/Public/AdditionalServiceHelp.vue'
import Integration from '~cp/Public/Integration.vue'
import Prices from '~cp/Public/Prices.vue'
import Advantages from '~cp/Public/Advantages.vue'
import Contacts from '~cp/Public/Contacts.vue'
import TryItOut from '~cp/Public/TryItOut.vue'
import Help from '~cp/Public/Help.vue'
import Blog from '~cp/Public/Blog.vue'
import Partnerial from '~cp/Public/Partnerial.vue'
import FriendlyThingsPage from '~cp/Public/FriendlyThingsPage.vue'
import PrivacyPolicyPage from '~cp/Public/PrivacyPolicyPage.vue'
import ProgrammablePage from '~cp/Public/ProgrammablePage.vue'
import TermsAndConditionsPage from '~cp/Public/TermsAndConditionsPage.vue'

import i18n from '@/i18n/i18n'

export default [
    {
        path: i18n.locale === 'lt' ? '/apie-mus' : '/about-us',
        name: 'About',
        component: About
    },
    {
        path: '/coming-soon',
        name: 'ComingSoon',
        component: ComingSoon
    },
    {
        path: i18n.locale === 'lt' ? '/3pl-paslaugos' : '/3pl-services',
        name: 'AdditionalService',
        component: AdditionalService
    },
    {
        path: '/additional-service-blog',
        name: 'AdditionalServiceBlog',
        component: AdditionalServiceBlog
    },
    {
        path: '/additional-service-help',
        name: 'AdditionalServiceHelp',
        component: AdditionalServiceHelp
    },
    {
        path: i18n.locale === 'lt' ? '/el-parduotuviu-sasaja' : '/marketplace-integrations',
        name: 'Integration',
        component: Integration
    },
    {
        path: i18n.locale === 'lt' ? '/kainos' : '/pricing',
        name: 'Prices',
        component: Prices
    },
    {
        path: i18n.locale === 'lt' ? '/privalumai' : '/benefits',
        name: 'Advantages',
        component: Advantages
    },
    {
        path: i18n.locale === 'lt' ? '/kontaktai' : '/contacts',
        name: 'Contacts',
        component: Contacts
    },
    {
        path: '/try-it-out',
        name: 'Try-it-out',
        component: TryItOut
    },
    {
        path: i18n.locale === 'lt' ? '/duk' : '/faq',
        name: 'Help',
        component: Help
    },
    {
        path: i18n.locale === 'lt' ? '/musu-partneriai' : '/our-partners',
        name: 'Partnerial',
        component: Partnerial
    },
    {
        path: i18n.locale === 'lt' ? '/blogas' : '/blog',
        name: 'Blog',
        component: Blog
    },
    {
        path: i18n.locale === 'lt' ? '/vartotoju-atsiliepimai' : '/customer-reviews',
        name: 'Reviews',
        component: Reviews
    },
    {
        path: '/terms-and-conditions',
        name: 'TermsAndConditionsPage',
        component: TermsAndConditionsPage
    },
    {
        path: '/programmable',
        name: 'ProgrammablePage',
        component: ProgrammablePage
    },
    {
        path: i18n.locale === 'lt' ? '/privatumo-politika' : '/privacy-policy',
        name: 'PrivacyPolicyPage',
        component: PrivacyPolicyPage
    },
    {
        path: i18n.locale === 'lt' ? '/draudziamu-daiktu-sarasas' : '/prohibited-items',
        name: 'FriendlyThingsPage',
        component: FriendlyThingsPage
    }
]



// WEBPACK FOOTER //
// ./src/router/modules/public-routes.js